import styled from 'styled-components';

import {
    DEFAULT_TICKET_FONT_SIZE,
    DEFAULT_TICKET_PRICE_COLOR,
} from 'common/entities/form/styleConfiguration/defaultValues';

import { bodyFontSize, latoFontFamilyStack } from 'common/styles/typography';

export const TicketTypePriceContainer = styled.div`
    font-weight: ${bodyFontSize};
    color: ${({ color }) => color || DEFAULT_TICKET_PRICE_COLOR};
    font-size: ${({ fontSize }) => (fontSize && `${fontSize}px`) || `${DEFAULT_TICKET_FONT_SIZE}px`};
    font-family: ${({ fontFamily }) => fontFamily || latoFontFamilyStack};
`;
